// src/components/HomePage.tsx
import React from "react";
import { countries } from "../data/staticData";
import CountrySelector from "./CountrySelector";

const HomePage: React.FC<{ onCountrySelect: (abbr: string) => void }> = ({ onCountrySelect }) => {
  return (
    <div className="home-page">
      <h1>Lost Abroad Minis</h1>
      <CountrySelector countries={countries} onCountrySelect={onCountrySelect} />
    </div>
  );
};

export default HomePage;
